<template>
    <div style="height: 164px;" class="footer">
        <p data-v-145d6ce4="">Copyright (c) 2010 国家计算机网络应急技术处理协调中心 版权所有</p>
        <p data-v-145d6ce4="">京ICP备10012421号   Email：ics-cert@cert.org.cn</p>
<!--        <p data-v-145d6ce4="">技术支持：<a data-v-145d6ce4="" href="#" style="color: #fff;">信联科技（南京）有限公司</a></p>-->
    </div>
</template>

<script>
    export default {
        name: "footerPage"
    }
</script>

<style scoped>
.footer{
    background: url("../assets/image/banner/footer.png") center center no-repeat;
    padding-top: 51px;
    max-width: 1920px;
    margin: 0 auto;
}
.footer p{
    font-size: 14px;
    line-height: 14px;
    font-weight: 400;
    color: #dbdbdb;
    text-align: center;
    line-height: 24px;
    margin-bottom: 0px;

}
</style>
